/**
 * @desc 创建bomECN变更或新品申请外发审批
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<string>;
export function request(
  body: defs.basics.PlmBomOutSupplyApprovalRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/product/bom/outgoing/approval`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
